import { exists } from '@/api'

export interface BatchUserRemovalCondition {
  userRegistrationBranchCode: string
  processType: string
  order: string
  userType: string
  isUpdate: boolean
  rangeFromRegistration: number
  rangeFromLastLend: number
  rangeFromExpirationDate: number
  userStatus: []
  basedDate: string
}

export function BatchUserRemovalConditionFromJSON(
  json: any
): BatchUserRemovalCondition {
  const _json = JSON.parse(json)

  return {
    userRegistrationBranchCode: exists(_json, 'user_registration_branch_code')
      ? _json.user_registration_branch_code
      : '',
    processType: exists(_json, 'process_type') ? _json.process_type : '',
    order: exists(_json, 'order') ? _json.order : '',
    userType: exists(_json, 'user_type') ? _json.user_type : '',
    isUpdate: exists(_json, 'is_update') ? _json.is_update : false,
    rangeFromRegistration: exists(_json, 'range_from_registration')
      ? _json.range_from_registration
      : 0,
    rangeFromLastLend: exists(_json, 'range_from_last_lend')
      ? _json.range_from_last_lend
      : 0,
    rangeFromExpirationDate: exists(_json, 'range_from_expiration_date')
      ? _json.range_from_expiration_date
      : 0,
    userStatus: exists(_json, 'user_status') ? _json.user_status : [],
    basedDate: exists(_json, 'based_date') ? _json.based_date : ''
  }
}
